import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../domain/services/api.service';

@Injectable({
    providedIn: 'root'
})
export class ApplicationService {
    constructor(private apiService: ApiService) {}

    getCurrentApplication(userId: number): Observable<any> {
        let httpParams = new HttpParams().set('userId', userId.toString());
        return this.apiService.get('/applications/current', httpParams);
    }

    patchCurrentApplication(application: any): Observable<any> {
        return this.apiService.patch(
            `/applications/${application.applicationId}`,
            application
        );
    }

    getSelectedProviderContacts(applicationId: number): Observable<any> {
        return this.apiService.get(
            `/applications/${applicationId}/selectedprovidercontacts`
        );
    }

    getSelectedProviderPrograms(applicationId: number): Observable<any> {
        return this.apiService.get(
            `/applications/${applicationId}/selectedproviderprograms`
        );
    }

    getPersonalInfo(applicationId: number): Observable<any> {
        return this.apiService.get(
            `/applications/${applicationId}/personalinfo`
        );
    }

    savePersonalInfo(personalInfo: any): Observable<any> {
        return this.apiService.put(
            `/applications/${personalInfo.applicationId}/personalinfo`,
            personalInfo
        );
    }

    getBackground(applicationId: number): Observable<any> {
        return this.apiService.get(`/applications/${applicationId}/background`);
    }

    saveBackground(personalInfo: any): Observable<any> {
        return this.apiService.put(
            `/applications/${personalInfo.applicationId}/background`,
            personalInfo
        );
    }

    getEducation(applicationId: number): Observable<any> {
        return this.apiService.get(`/applications/${applicationId}/education`);
    }

    saveEducation(education: any): Observable<any> {
        return this.apiService.put(
            `/applications/${education.applicationId}/education`,
            education
        );
    }

    getDisclosure(applicationId: number): Observable<any> {
        return this.apiService.get(`/applications/${applicationId}/disclosure`);
    }

    saveDisclosure(disclosure: any): Observable<any> {
        return this.apiService.put(
            `/applications/${disclosure.applicationId}/disclosure`,
            disclosure
        );
    }
}
